// extracted by mini-css-extract-plugin
export var button = "_d0-4";
export var hasDarkBackground = "_d0-7";
export var hasLightBackground = "_d0-6";
export var iconWrapper = "_d0-0";
export var large = "_d0-2";
export var medium = "_d0-1";
export var small = "_d0-5";
export var xsmall = "_d0-3";